import React, { useState, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import axios from 'axios';
import { useStore } from 'react-redux';
import Piechart from './piechart';
import { Box } from '@mui/system';
import moment from 'moment';

export default function AllCompanyTotalBalance() {
  const store: any = useStore();

  const [get_table_data, set_table_data]: any = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  function fetch_table_data() {
    const isStartValid = moment(startDate, 'YYYY-MM-DD', true).isValid();
    const isEndValid = moment(endDate, 'YYYY-MM-DD', true).isValid();
    const formattedStart = isStartValid ? moment(startDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : undefined;
    const formattedEndRaw = isEndValid ? moment(endDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : undefined;
    const formattedEnd =
      formattedStart && formattedEndRaw && moment(formattedEndRaw).isBefore(formattedStart) ? formattedStart : formattedEndRaw;

    const params: Record<string, string> = {};
    if (formattedStart) {
      params.start = formattedStart;
    }
    if (formattedEnd) {
      params.end = formattedEnd;
    }

    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_SERVER}/parcels/on-delivery-stats`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
        params,
      })
      .then((res) => {
        const data = Array.isArray(res.data)
          ? res.data.slice().sort((a: any, b: any) => Number(b.count) - Number(a.count))
          : [];
        set_table_data(data);
      })
      .catch(() => {
        set_table_data([]);
      })
      .finally(() => {
        setHasFetched(true);
        setLoading(false);
      });
  }

  useEffect(() => {
    fetch_table_data();
    // eslint-disable-next-line
  }, [startDate, endDate]);

  const showNoDataMessage = hasFetched && !loading && startDate && Array.isArray(get_table_data) && get_table_data.length === 0;
  const dateLabel = endDate ? `${startDate} to ${endDate}` : startDate;

  return (
    <>
      <Box className="mb-3">
        <div className="flex flex-col sm:flex-row gap-3">
          <TextField
            label="Start date"
            type="date"
            variant="standard"
            value={startDate}
            onChange={(e) => {
              const value = e.target.value;
              setStartDate(value);
              if (!value) {
                setEndDate('');
              }
            }}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End date"
            type="date"
            variant="standard"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            disabled={!startDate}
          />
        </div>
      </Box>
      <Box>
        <Piechart get_table_data={get_table_data} />
      </Box>
      {showNoDataMessage && <div className="mt-2 text-sm text-gray-600 text-center">No data found for {dateLabel}.</div>}
    </>
  );
}
